export default {
  namespaced: true,

  state: {
    items: []
  },

  mutations: {
    set(state, items) {
      state.items = items;
    },

    retrieve(state) {
      if (!state.items.length) {
        window.Ajax.get('/vulnerability-consent-methods')
          .then(response => {
            state.items = response.data;
          })
          .catch(err => {});
      }
    }
  },

  getters: {
    all(state) {
      return state.items;
    }
  }
};
